<template>
  <div>
    <!-- <a
        href="https://api.whatsapp.com/send?phone=79876727522"
        target="_blank"
        rel="noopener"
      >
        <img class='vk2' alt="" src="../assets/wal.png" />
      </a> -->
      <a class="btn_telegram_share" href="https://t.me/+79876727522" target="_blank" rel="noopener">
        <img class='vk' alt="" src="../assets/telega.png"/>
      </a>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.vk {
  position: fixed;
  width: 4vw;
  bottom: 2vw; 
  right: 2vw;
  transition: all 0.4s ease;
  z-index: 1;
}
.vk:hover {
  width: 4.2vw;
  transition: all 0.4s ease;
}
.vk2 {
  position: fixed;
  width: 4.2vw;
  bottom: 7vw; 
  right: 2vw;
  transition: all 0.4s ease;
  z-index: 1;
}
.vk2:hover {
  width: 4.3vw;
  transition: all 0.4s ease;
}

@media (max-width: 767px) {
    .vk {
        width: 55px;
        bottom: 20px; 
        right: 20px;
    }
    .vk:hover {
        width: 60px;
    }
    .vk2 {
        width: 63px;
        bottom: 85px; 
        right: 20px;
    }
    .vk2:hover {
        width: 68px;
    }

}

</style>